define('chaves-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('chaves.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Chaves', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
      return {

      }
    }
  ]);
});


